<section>
    <dx-data-grid
        #dxAdminPortfolioDataGrid
        id="portfoliosDataGrid"
        [dataSource]="dataGridSource"
        [showColumnLines]="false"
        [showRowLines]="true"
        [showBorders]="false"
        (onRowPrepared)="dxGridRowPrepared($event)" 
        (onOptionChanged)="onSearchValueChanged($event)"
        (onContextMenuPreparing)="onContextMenuPreparing($event)"
    >
        <dxo-data-grid-load-panel [enabled]="true"></dxo-data-grid-load-panel>

        <dxo-data-grid-search-panel
            [visible]="true"
            alignment="left"
            [text]="portfolioFilterSettings || ''"
            [highlightSearchText]="false"
            placeholder="Search Portfolios..."
            width="300">
        </dxo-data-grid-search-panel>
        
        <!-- Toolbar -->
        <dxo-data-grid-toolbar>
            <dxi-data-grid-item name="searchPanel" location="before"></dxi-data-grid-item>
            <dxi-data-grid-item location="after">
                <dx-select-box
                    width="130"
                    [items]="activeFilterItems"
                    [inputAttr]="{ 'aria-label': 'Value' }"
                    displayExpr="text"
                    valueExpr="value"
                    value="active"
                    (onValueChanged)="activeDropdownChanged($event)">
                </dx-select-box>
            </dxi-data-grid-item>
        </dxo-data-grid-toolbar>

        <dxi-data-grid-column cssClass="dx-grid-cell-wrapped" width="200" dataType="string" dataField="name" caption="Portfolio Name" alignment="left" cellTemplate="workspaceNameTemplate">
            <div *dxTemplate="let cellData of 'workspaceNameTemplate'">
                <a [href]="'/#/useraccount/admin/portfolios/' + cellData.row.data.workspaceId">
                    <div>{{ cellData.value }}</div>
                </a>
            </div>
        </dxi-data-grid-column>
        <dxi-data-grid-column cssClass="dx-grid-cell-wrapped" width="200" dataType="string" dataField="companyName" caption="Company Name" alignment="left"></dxi-data-grid-column>
        <dxi-data-grid-column cssClass="dx-grid-cell" dataType="string" dataField="workspacePropertyCount" caption="Properties" alignment="left" cellTemplate="workspacePropertyCountTemplate">
            <div *dxTemplate="let cellData of 'workspacePropertyCountTemplate'">
                <a [href]="'/#/useraccount/admin/portfolios/' + cellData.row.data.workspaceId + '?tabIndex=1'">
                    <div class="properties-count">{{ cellData.value }} Properties</div>
                </a>
            </div>
        </dxi-data-grid-column>
        <dxi-data-grid-column cssClass="dx-grid-cell" dataType="string" dataField="workspaceUserCount" caption="Users" alignment="left" cellTemplate="workspaceUserCountTemplate">
            <div *dxTemplate="let cellData of 'workspaceUserCountTemplate'">
                <a [href]="'/#/useraccount/admin/portfolios/' + cellData.row.data.workspaceId + '?tabIndex=2'">
                    <div class="properties-count">{{ cellData.value }} Users</div>
                </a>
            </div>
        </dxi-data-grid-column>
        <dxi-data-grid-column cssClass="dx-grid-cell" dataType="string" dataField="workspaceInviteCount" caption="Pending Invites" alignment="left" cellTemplate="workspaceInviteCountTemplate">
            <div *dxTemplate="let cellData of 'workspaceInviteCountTemplate'">
                <a [href]="'/#/useraccount/admin/portfolios/' + cellData.row.data.workspaceId + '?tabIndex=3'">
                    <div class="properties-count">{{ cellData.value }} Invites</div>
                </a>
            </div>
        </dxi-data-grid-column>
        <dxi-data-grid-column cssClass="dx-grid-cell" dataField="createdOn" caption="Date Added" dataType="date" alignment="left"></dxi-data-grid-column>        

        <dxi-data-grid-column cssClass="dx-grid-cell" dataType="string" dataField="isActive" caption="Status" alignment="left" cellTemplate="activeTemplate" ></dxi-data-grid-column>
        <div *dxTemplate="let cellData of 'activeTemplate'">
            <div *ngIf="cellData.row.data.isActive">
                <span class="status-badge badge-active">Active</span>
            </div>
            <div *ngIf="!cellData.row.data.isActive">
                <span class="status-badge badge-inactive">Inactive</span>
            </div>
        </div>

        <dxi-data-grid-column cssClass="dx-grid-cell" alignment="right" cellTemplate="workspaceId">
            <div *dxTemplate="let cellData of 'workspaceId'">                
                <dx-button 
                    id="btnShowActionMenu"
                    hint="Action Menu"
                    [hoverStateEnabled]="false"
                    [activeStateEnabled]="false"
                    stylingMode="text" 
                    type="normal" 
                    icon="overflow" 
                    (onClick)="showActionMenu($event)">
                </dx-button>                  
            </div>
        </dxi-data-grid-column>
        
        <dxo-data-grid-paging [pageSize]="10"> </dxo-data-grid-paging>
        <dxo-data-grid-pager
            [visible]="true"
            [allowedPageSizes]="allowedPageSizes"
            [displayMode]="'compact'"
            [showPageSizeSelector]="true"
            [showInfo]="true"
            [showNavigationButtons]="true">
        </dxo-data-grid-pager>
    </dx-data-grid>
</section>

<sp-modal #deactivatePortfolioModal title="DEACTIVATE THIS PORTFOLIO" (confirm)="deactivatePortfolio()" confirmButtonText="OK" [isWarning]="true">
    Are you sure you want to deactivate this portfolio?  Users will no longer be able to access this portfolio and its properties anymore.
</sp-modal>

<sp-modal #reactivatePortfolioModal title="DEACTIVATE THIS PORTFOLIO" (confirm)="reactivatePortfolio()" confirmButtonText="OK" [isWarning]="true">
    Are you sure you want to reactivate this portfolio?
</sp-modal>